import { render, staticRenderFns } from "./changePassword.vue?vue&type=template&id=c49de7fe&scoped=true&"
import script from "./changePassword.vue?vue&type=script&lang=js&"
export * from "./changePassword.vue?vue&type=script&lang=js&"
import style0 from "./changePassword.vue?vue&type=style&index=0&id=c49de7fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49de7fe",
  null
  
)

export default component.exports